// 巧巧郎官网与会员区的边界；不引用买即可的域名、登录页或默认会员路由。
export function isKkrenMemberPath (path) {
  return typeof path === 'string' && /^\/(?![/\\])/.test(path)
}

export function kkrenMemberUrl (path = '/') {
  // 路径只进入本站 hash 路由，不允许把外部网址作为登录回跳。
  const safePath = isKkrenMemberPath(path) ? path : '/'
  return '/app/index.html#' + safePath
}

export function kkrenHomeUrl (route) {
  const query = new URLSearchParams(window.location.search)
  // accessToken 已由会员守卫消费，不把凭证带到可分享的官网地址。
  query.delete('accessToken')
  Object.entries(route.query || {}).forEach(([key, value]) => {
    if (key === 'accessToken') return
    query.delete(key)
    ;(Array.isArray(value) ? value : [value]).forEach(item => {
      if (item !== undefined) query.append(key, item == null ? '' : item)
    })
  })
  if (route.name === 'Register') query.set('auth', 'register')
  if (route.name === 'Login' || route.name === 'NoLoginHome') query.set('auth', 'login')
  const search = query.toString()
  return '/' + (search ? '?' + search : '')
}
